var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 380 258.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-10,.cls-11,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#263238;}.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-3,.cls-7{fill:#263238;}.cls-4,.cls-6,.cls-8{fill:#fff;}.cls-9{clip-path:url(#clip-path);}.cls-10{isolation:isolate;opacity:0.36;}.cls-11{stroke-miterlimit:10;}.cls-12{font-size:39.49px;}.cls-12,.cls-13{font-family:Poppins-SemiBold, Poppins;font-weight:600;}.cls-13{font-size:20.03px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.66,254.15l-307.83-1v-60a4.49,4.49,0,0,1,4.5-4.5h295a4.49,4.49,0,0,1,4.5,4.5Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 132,
    y1: 5.82,
    x2: 132,
    y2: 255.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.14,
    y: 32.49,
    width: 77.7,
    height: 66.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 33.03,
    y: 35.82,
    width: 69.93,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,54C90.39,63,72.37,68.89,51.47,78.22A86,86,0,0,0,33,89.22v6.6H103Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,35.82H74.9c-3.12,2.67-6.82,5.66-11.18,8.86-16,11.71-9,23.42,10.12,14.91C83.67,55.21,94.63,45.1,103,36.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.08,42.55c0-4.89-6.08-1.06-12,3.87v12.4C38.87,53.07,45.08,46.92,45.08,42.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 83.42,
    cy: 79.81,
    r: 7.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.94,62a5.59,5.59,0,1,1-5.59-5.59h0A5.59,5.59,0,0,1,50.94,62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bed--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.33,142.49V253.15h64.33V142.49Zm6.24,19.45v-9.56H54v9.56Zm5.86,0v-9.56H60v9.56Zm6,0v-9.56h3v9.56Zm5.4,0v-9.56h3v9.56Zm5.4,0v-9.56h3v9.56Zm5.41,0v-9.56h3v9.56Zm5.4,0v-9.56h3v9.56Zm5.41,0v-9.56h3v9.56Zm5.4,0v-9.56h3v9.56Zm7.6,0h-2.2v-9.56h2.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 44.33,
    y: 137.07,
    width: 3.56,
    height: 116.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 105.1,
    y: 137.07,
    width: 3.56,
    height: 116.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.12,166s-3.64-1-11.68,2.1-12.24,13.2-12.82,14.35-3.63,4-2.68,5.36,3.45,1,3.45,1H113.9S107,164.67,87.12,166Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.94,163.11s4.44,2,6.86,3.23,4,1.82,2.83-1.62-5.24-9.07-3.42-10.89,38.12,4.23,38.12,4.23v31.7H102l1.42-21s3.43,1.41,5.65-.81A30.36,30.36,0,0,0,112.94,163.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "124.64 173.82 129.3 178.47 118.24 183.13 132.21 188.76 138.42 188.76 138.42 155.97 118.63 156.36 121.15 164.7 124.64 173.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.74,175.82s.62,8.88,1.24,11.71,3.1,3,7.23,2.42,24.58-2.42,26.64-3.23-21.48-9.49-24.37-10.3S90.33,172.6,90.74,175.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.12,169s.2,2.83-.6,3-1.62-4.84-1.62-4.84-1.41,5.65-4.64,5.45-3-11.91,2-18,10.29-8.08,13.93-6.46,5.65,5.85,5.65,5.85a33.36,33.36,0,0,1,2.22,5c.2,1.21-3,.61-6.26,1.21s-3.83-.4-5.65,2.22S90.12,169,90.12,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.12,169A28.51,28.51,0,0,0,103,176.23c8.08,2,14.38-2.14,13.73-6.06-1.21-7.26-7.67-12.51-7.67-12.51a5.63,5.63,0,0,0-2-4.24c-2-1.41-4-1.41-4.24.2a20.8,20.8,0,0,0-.2,2.22l2.83,1.62-.81.6a20.74,20.74,0,0,0-3.84-.6c-1.41,0-1.21,1.41-2.82,1.41s-2.63-3.63-3.23-1.82S90.12,169,90.12,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.33,171.82s2.42-8.08,4.85-11.91,7.47,0,7.67,2.62-2.63,3.64-4,5.45.2,4.85-.4,6.26S96,178.05,93.33,171.82Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "100.62 169.57 103.45 172.4 104.66 171.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.33,179.46s-11.51-1.21-20-2.42-17-4.85-21-5.25-3.63,1.82-4.44,4.44.4,5,1.21,5,.41.81.81,0,.61-5.45.61-5.45a52,52,0,0,0,5,1.61,8.24,8.24,0,0,0,4.24,0s25.24,13.13,30.08,13.53,4.85-3.63,4.44-6.06S134.33,179.46,134.33,179.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "111.64 174.58 108.21 184.19 124.22 190.14 134.98 190.14 134.98 178.01 111.64 174.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136.66,149.15s-20.66,1.34-19.33,6,18,13,21.67,13S136.66,149.15,136.66,149.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.88,179.44a7.51,7.51,0,0,0-6.4,4.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "116.3 163.34 121.34 174.4 128.33 175.56 121.34 163.92 116.3 163.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.33,146.82s29.67,5.33,36.33,5.33,15.34-3,40.34.34,38,18.66,41.33,20.33,21,1.33,31.67,4,20.33,15.33,20.33,15.33h-173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.66,170.82s11,17.33,23,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.66,172.82s7,7.33,12.67,11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.83,144.51s-9.67,1-9.67,3.67-4,8.95-1.26,42.79c.11,1.38,20.9,1.75,20.83,0-1.72-41.69,4.77-43.46,3.43-45.12S141.83,144.51,141.83,144.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M358.66,254.15l-307.83-1v-60a4.49,4.49,0,0,1,4.5-4.5h295a4.49,4.49,0,0,1,4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M358.66,254.15l-307.83-1v-60a4.49,4.49,0,0,1,4.5-4.5h295a4.49,4.49,0,0,1,4.5,4.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.66,254.15l-307.83-1v-60a4.49,4.49,0,0,1,4.5-4.5h295a4.49,4.49,0,0,1,4.5,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M350.33,188.65H118.18v64.72l240.48.78-3.83-61a4.49,4.49,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.86,198.06l9.48,55a1,1,0,0,1-.93,1.07h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M350.33,188.65H265.25A4.25,4.25,0,0,0,261,192.9l-4.34,60.25,102,1-3.83-61a4.49,4.49,0,0,0-4.5-4.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "192.81 253.46 197.35 194.42 189.69 253.18 192.81 253.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "348.14 253.46 352.68 194.42 345.02 253.18 348.14 253.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "205.16 253.46 202.03 194.42 202.01 253.18 205.16 253.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "272.66 253.46 269.53 194.42 269.51 253.18 272.66 253.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "142.42 253.46 146.96 194.42 139.29 253.18 142.42 253.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "154.77 253.46 151.63 194.42 151.61 253.18 154.77 253.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.21,188.23c-1.6,0-4.31,1.23-4.61,2.8-1.58,8.49.23,28.33.23,37.62a216,216,0,0,1-1.75,24.5h24.53s-.62-37.85-1.28-50c-.61-11.23,4.91-14.49,4.91-14.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61,176.82,53.94,163V143.65H47.15V163l-7.09,13.81a2.44,2.44,0,0,0,1,3.28,2.47,2.47,0,0,0,1.13.27H58.86a2.44,2.44,0,0,0,2.44-2.44A2.36,2.36,0,0,0,61,176.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "68.29 147.65 32.79 147.65 41.67 117.15 59.42 117.15 68.29 147.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.33,
    y: 179.82,
    width: 51.33,
    height: 73.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 56.33,
    y: 179.82,
    width: 24.33,
    height: 73.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.66,
    y: 184.82,
    width: 21.67,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63,
    y: 191.15,
    width: 11,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.66,
    y: 206.32,
    width: 21.67,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63,
    y: 212.65,
    width: 11,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.66,
    y: 227.82,
    width: 21.67,
    height: 15.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 63,
    y: 234.15,
    width: 11,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.85,
    y: 0.5,
    width: 236.67,
    height: 131.32,
    rx: 6.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 148.68,
    y: 8.23,
    width: 218.05,
    height: 113.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M370.17,62.5a2.61,2.61,0,1,0,2.61,2.61h0a2.59,2.59,0,0,0-2.6-2.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ground--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    y: 252.49,
    width: 380,
    height: 6
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(212.03 53.57) scale(1.1 1)"
  }, "REST."), /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(194.8 82.04) scale(0.97 1)"
  }, "It\u2019s part of the", /*#__PURE__*/React.createElement("tspan", {
    x: 16.42,
    y: 22
  }, "program ! "))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestDay);
export default __webpack_public_path__ + "static/media/rest_day.f40bb852.svg";
export { ForwardRef as ReactComponent };